"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterLocalDateCellFactory = exports.FilterLocalDateCell = void 0;
const react_1 = __importDefault(require("react"));
const local_date_field_1 = require("../../../components/local-date-field/local-date-field");
const filter_interval_cell_factory_1 = require("./filter-interval-cell-factory");
exports.FilterLocalDateCell = (0, filter_interval_cell_factory_1.filterIntervalCellFactory)(local_date_field_1.LocalDateField);
function useFilterLocalDateCellFactory(representation) {
    const Field = (props) => (react_1.default.createElement(local_date_field_1.LocalDateField, { ...props, representation: representation }));
    return (0, filter_interval_cell_factory_1.filterIntervalCellFactory)(Field);
}
exports.useFilterLocalDateCellFactory = useFilterLocalDateCellFactory;
//# sourceMappingURL=filter-local-date-cell.js.map